module.exports = __webpack_public_path__ + "img/a2-s28.7a376839.jpg";